import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { MonitoringService } from 'monitoring';
import { LandingPage } from 'prismic';
import { LazySliceService } from '../../services/lazy-slice.service';
import { PrismicService } from '../../services/prismic.service';

@Injectable({
  providedIn: 'root',
})
export class LandingPageResolve implements Resolve<Promise<LandingPage>> {
  private prismic = inject(PrismicService);
  private lazySliceService = inject(LazySliceService);
  private monitoringService = inject(MonitoringService);

  public async resolve(route: ActivatedRouteSnapshot): Promise<LandingPage> {
    if (!route.data.landingPageData) return;

    try {
      const landingPage = await this.prismic.convertLandingPage(route.data.landingPageData);
      await Promise.all(landingPage.slices.map(slice => this.lazySliceService.loadSliceComponent(slice.type)));
      return landingPage;
    } catch (err) {
      this.monitoringService.log(err);
      console.trace();
    }
  }
}
